<template>
  <div class="em">
    <h4>
      <img class="em-logo" src="@/assets/img/em-logo.png" alt="" />
      <span>EaseMoni</span>
    </h4>
    <h5>Easy Loans for Your Every Need</h5>
    <ul class="list">
      <li>
        <img class="Mask-group" src="@/assets/img/Mask-group1-2.png" alt="" />
        <p class="title">Competitve Interest</p>
        <p class="desc">As low as 3% monthly interest rate</p>
      </li>
      <li>
        <img class="Mask-group" src="@/assets/img/Mask-group2.png" alt="" />
        <p class="title">Easy apply process</p>
        <p class="desc">Access the credit with minimum documentation</p>
      </li>
      <li>
        <img class="Mask-group" src="@/assets/img/Mask-group3.png" alt="" />
        <p class="title">Quick disbursement</p>
        <p class="desc">Loan directly to your linked bank account</p>
      </li>
      <li>
        <img class="Mask-group" src="@/assets/img/Mask-group4.png" alt="" />
        <p class="title">Revolving loan</p>
        <p class="desc">New feature on board, more than one loan running</p>
      </li>
    </ul>
    <img
      class="google_play"
      src="@/assets/img/google_play.png"
      alt=""
      @click="toEM"
    />
  </div>
</template>

<script>
export default {
  methods: {
    toEM() {
      window.location.href = "https://myem.onelink.me/qpgB/aan3leel";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/public.scss";

.em {
  width: 100%;
  background-image: url("~@/assets/img/em-bg.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 80px 120px 56px;
  text-align: center;
  h4 {
    color: #210f60;
    font-size: 44px;
    font-weight: 600;
    line-height: 50px;
    text-align: center;
    img {
      width: 58px;
      vertical-align: middle;
    }
  }
  h5 {
    margin: 32px 0 30px;
    color: #210f60;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
  }
  .list {
    @include flex-base;
    li {
      width: 250px;
      @include flex-center;
      flex-direction: column;
      img {
        width: 250px;
      }
      .title {
        margin-bottom: 16px;
        color: #210f60;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
      }
      .desc {
        height: 33px;
        color: #210f60d9;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
  .google_play {
    width: 270px;
    margin-top: 48px;
    cursor: pointer;
  }
}
</style>
